import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import { Select, Input } from "../partials";

let makesData = window.makes_data ?? [];
let makes = [{ value: '', label: 'Make' }];

makesData.forEach(make => {
    makes.push({
        value: make.MAKE_NAME,
        label: make.MAKE_NAME === "RAM" ? "Ram" : make.MAKE_NAME,
        id: make.MAKE_SEQ
    })
});

let typesData = window.types_data ?? [];
let types = [{ value: '', label: 'Type' }];

typesData.forEach(type => {
    types.push({
        value: type,
        label: type,
    })
});

class HomeFilters extends Component {

    state = {
        make: null,
        type: null,
        keywords: null
    };

    search = () => {
        const { make, type, keywords } = this.state;
        let href = `${window.origin}/our-vehicles`;

        if (make?.value && make.value !== 'undefined') {
            href += `/make-${make.value}`;
        }

        if (type?.value && type.value !== 'undefined') {
            href += `/type-${type.value}`;
        }

        if (this.props.query) {
            href += this.props.query;
        }

        if (keywords) {
            href += (href.includes('?') ? '&' : '/?') + `keywords=${encodeURIComponent(keywords)}`;
        }

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'filterHomePage',
            filterMake: make?.value || 'All makes',
            filterBodyType: type?.value || 'All body types',
            filterKeywords: keywords || ''
        });

        window.location.href = href;
    };


    handleEnterSubmit = (e) => {
        if(e.key === "Enter"){
            this.search();
        }
    }

    renderFilter = (filter, index) => {
        return (
            <div className="home-filters__filter" key={index}>
                <Select {...filter} modifiers={['simple']}/>
            </div>
        )
    };

    render() {
        const filters = [
            {
                placeholder: 'Make',
                options: makes,
                onChange: (make) => this.setState({ make })
            }
            // ,
            // {
            //     placeholder: 'Type',
            //     options: types,
            //     onChange: (type) => this.setState({ type })
            // },
        ];

        return (
            <Fragment>
                <div className={`home-filters__content`}>
                    {filters.map(this.renderFilter)}
                    <div className="home-filters__filter home-filters__filter--keywords">
                        <Input
                            onChange={(e) => {
                                this.setState({ keywords: e.target.value })
                            }}
                            onKeyPress={this.handleEnterSubmit}
                            name={`keywords`}
                            modifiers={['form']}
                            placeholder={`Search`}
                        />
                    </div>
                </div>
                <div className={`home-filters__search`} onClick={this.search}>Browse</div>
            </Fragment>
        );
    }
}

export default function (el, props) {
    ReactDOM.render(<HomeFilters {...props} />, el)
}
